import pipe from 'ramda/es/pipe'
import head from 'ramda/es/head'
import prop from 'ramda/es/prop'
import defaultTo from 'ramda/es/defaultTo'

const log = x => { console.log(x); return x }

export default class ClickSvgValidator {
    static isAnswerCorrect(answer) {
        const safeInpuVal = pipe(head, defaultTo({value:undefined}), prop('value'))
        return head(answer.question().correctAnswers()) === safeInpuVal(answer.userInput())
    }
}